<template>
    <div class="dashboard-edit">
        <div class="dashboard_contents">
            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <tabs class="pets-component">
                            <tab :name="$store.getters.t('user_profile_filter_actual_wards')" :selected="true">
                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshPetsArchvie" tab-type="PET_TYPE_VOLUNTEER"
                                             :selectCategory="selectPetCategory"
                                             :selectStatus="selectStatus"
                                    />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('user_profile_filter_projects')">
                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshProjectArchvie" tab-type="PROJECTS"
                                             :selectCategory="selectProjectCategory"
                                    />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('user_classifieds_tab_my_pets')">

                                <div class="tabs__body">
                                    <tab-pet @archiveHookTab="refreshPetsArchvie" tab-type="PET_TYPE_MYSELF"
                                             :selectCategory="selectPetCategory"
                                    />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('user_classifieds_tab_pets_archive')">
                                <div class="tabs__body">
                                    <tab-pet  tab-type="ARCHIVE__PETS"
                                              :refreshArchive = "petsArchive"
                                               :selectCategory="selectPetCategory"
                                    />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('volunteer_backend_pets_projects_archive')">
                                <div class="tabs__body">
                                    <tab-pet  tab-type="ARCHIVE__PROJECTS"
                                              :refreshArchive = "projectsArchive"
                                               :selectCategory="selectProjectCategory"
                                    />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('homestays_title')" v-if="userFacilities && (+userFacilities.homestay > 0)">
                                <div class="tabs__body">
                                    <tab-homestays />
                                </div>
                            </tab>
                            <tab :name="$store.getters.t('main_menu_ads')" v-if="userFacilities && (+userFacilities.facilities > 0)">
                                <div class="tabs__body">
                                    <tab-facilities :selectCategory="selectPhotoHelp"/>
                                </div>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>
            <!-- end /.container -->
        </div>
    </div>

</template>

<script>
import Tabs from './Profile/tabs/Tabs'
import Tab from './Profile/tabs/Tab'
import TabPet from "./Profile/tabs/TabPet/TabPet";
import TabHomestays from "./Profile/tabs/TabPet/TabHomestays";
import TabFacilities from "./Profile/tabs/TabPet/TabFacilities";

export default {
    components:{
        Tabs,
        Tab,
        TabPet,
        TabHomestays,
        TabFacilities
    },
    data() {
        return {
            petsArchive: false,
            projectsArchive: false,
            selectPetCategory:{
                placeholder: this.$store.getters.t('catalog_filter_categories'),
                list: []
            },

            selectProjectCategory:{
                placeholder: this.$store.getters.t('volunteer_backend_pets_project_categories'),
                list: []
            },

            selectStatus:{
                placeholder: this.$store.getters.t('preview_modal_status'),
                list: [
                    {
                        id: 1,
                        name: this.$store.getters.t('volunteer_backend_pets_status_can_raise'),
                    },
                    {
                        id: 0,
                        name: this.$store.getters.t('volunteer_backend_pets_status_cannot_raise'),
                    },
                ]
            },
            selectPhotoHelp:{
                placeholder: this.$store.getters.t('facilities_store_form_service_type'),
                list: [
                    {
                        id: 'photo_help',
                        name: this.$store.getters.t('facilities_store_form_photo_help'),
                    },
                    {
                        id: 'pr_help',
                        name: this.$store.getters.t('facilities_store_form_pr'),
                    },
                    {
                        id: 'auto_help',
                        name: this.$store.getters.t('facilities_store_form_auto_help'),
                    },
                    {
                        id: 'giveaway',
                        name: this.$store.getters.t('facilities_store_form_giveaway'),
                    },

                ]
            },
        }
    },
    props: ['user'],
    created() {},
    mounted() {
        this.getPetsCategory();
        this.getProjectCategory();
    },
    computed: {

        userFacilities(){
            let stateFacilities = this.$store.getters.getFacilities;


            return {
                homestay: stateFacilities.homestay || 0,
                facilities: (+stateFacilities.auto_help || 0) + (+stateFacilities.giveaway || 0) + (+stateFacilities.photo_help || 0) + (+stateFacilities.pr_help || 0)
            };
        }

    },
    methods: {
        refreshPetsArchvie(tabType){
            this.petsArchive = true;

            setTimeout(() => {
                this.petsArchive = false;
            }, 1000);
        },

        refreshProjectArchvie(tabType){
            this.projectsArchive = true;

            setTimeout(() => {
                this.projectsArchive = false;
            }, 1000);
        },

        getPetsCategory() {
            let url = '/api/pets/categories';
            axios.get(url)
                .then(response => {
                    response = response.data;
                    if (response.success){
                        this.selectPetCategory.list = response.data;
                    }
                })
                .catch();
        },

        getProjectCategory() {
            let url = '/api/projects/categories';
            axios.get(url)
                .then(response =>{
                    response = response.data;
                    if (response.success){
                        this.selectProjectCategory.list = response.data;
                    }
                })
                .catch();
        }
    }
}
</script>

<style lang="scss">

.tabs__body{
    background: transparent;
}

.tabs__content{
    background: #fff;
    padding: 18px 47px 0;
    margin-bottom: 30px;
}

@media screen and (max-width: 768px){
    .tabs__content {
        padding: 18px 20px 0;
    }
}



</style>
